import * as React from 'react'
import Loadable from 'react-loadable'
import { ErrorIndicator, LoadingIndicator } from '../../Shared/LoadIndicators'

// tslint:disable-next-line
function Loading(props) {
  if (props.error) {
    return <ErrorIndicator message="3D previsualization could not be loaded" />
  } else if (props.pastDelay) {
    return <LoadingIndicator />
  } else {
    return null
  }
}

const LoadableComponent = Loadable({
  loader: () => import('./PreViz'),
  loading: Loading,
  delay: 500
})

export default class App extends React.Component {
  render() {
    return <LoadableComponent />
  }
}



// WEBPACK FOOTER //
// ./src/Components/Workspace/PreViz/index.tsx